import React, { useState, useEffect } from "react";
import { useIntl, FormattedMessage } from 'react-intl';
import {
	Collapse,
	TextField,
	Grid,
	Box,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Switch from "react-switch";

const FILTER_STATE_INIT = {
	apellido: '',
	nombre: '',
	legajoNumero: '',
	email: '',
	documentoNumero: '',
	base: null,
	categoria: null,
	perfil: null,
	region: null,
	subregion: null,
	showInactivos: false,
};

const STORAGE_KEY = 'PersonasGrid_filtros';

const readStorage = () => {
	try {
		const saved = localStorage.getItem(STORAGE_KEY);
		if (saved) return JSON.parse(saved);
	} catch (e) {}
	return null;
};

const PersonasGridFiltros = (props) => {
	const intl = useIntl();

	const [showPersistirFiltros, setShowPersistirFiltros] = useState(() => {
		const saved = readStorage();
		return saved && saved.activo === true;
	});

	const [filtersState, setFiltersState] = useState(() => {
		const saved = readStorage();
		if (saved && saved.activo) {
			const { activo, ...filters } = saved;
			return { ...FILTER_STATE_INIT, ...filters };
		}
		return { ...FILTER_STATE_INIT };
	});

	useEffect(() => {
		if (props.filterResetInputs) {
			setFiltersState({ ...FILTER_STATE_INIT });
			if (showPersistirFiltros) {
				localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: true, ...FILTER_STATE_INIT }));
			}
			props.setFilterResetInputs && props.setFilterResetInputs(false);
		}
	}, [props.filterResetInputs]);

	const triggerFilter = (updatedState) => {
		if (showPersistirFiltros) {
			localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: true, ...updatedState }));
		}
		props.setFilterQuery({
			...updatedState,
			base: updatedState.base ? updatedState.base.value : '',
			categoria: updatedState.categoria ? updatedState.categoria.value : '',
			perfil: updatedState.perfil ? updatedState.perfil.value : '',
			region: updatedState.region ? updatedState.region.value : '',
			subregion: updatedState.subregion ? updatedState.subregion.value : '',
		});
	};

	const handleChange = (name, value) => {
		setFiltersState((prev) => ({ ...prev, [name]: value }));
	};

	const handleOnEnter = (e, name) => {
		if (e.keyCode === 13) {
			e.preventDefault();
			handleBuscar({ ...filtersState, [name]: e.target.value });
		}
	};

	const handleSelectChange = (name, value) => {
		setFiltersState((prev) => ({ ...prev, [name]: value }));
	};

	const handleSwitch = (name, value) => {
		const updated = { ...filtersState, [name]: value };
		setFiltersState(updated);
		triggerFilter(updated);
	};

	const handleBuscar = (state) => {
		const current = state !== undefined ? state : filtersState;
		triggerFilter(current);
	};

	const handlePersistirFiltros = (value) => {
		setShowPersistirFiltros(value);
		if (value) {
			localStorage.setItem(STORAGE_KEY, JSON.stringify({ activo: true, ...filtersState }));
		} else {
			localStorage.removeItem(STORAGE_KEY);
		}
	};

	const { filtersData } = props;
	const bases = (filtersData && filtersData.base) ? filtersData.base : [];
	const categorias = (filtersData && filtersData.categoria) ? filtersData.categoria : [];
	const perfiles = (filtersData && filtersData.perfil) ? filtersData.perfil : [];
	const regiones = (filtersData && filtersData.region) ? filtersData.region : [];
	const subregiones = (filtersData && filtersData.subregion) ? filtersData.subregion : [];

	return (
		<Collapse in={props.dropdownActive}>
			<Grid container item xs={12} spacing={2} style={{ marginBottom: 16, marginTop: 4 }}>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.apellido', defaultMessage: 'Apellido' })}
						name="apellido"
						value={filtersState.apellido}
						onChange={(e) => handleChange('apellido', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'apellido')}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.nombre', defaultMessage: 'Nombre' })}
						name="nombre"
						value={filtersState.nombre}
						onChange={(e) => handleChange('nombre', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'nombre')}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.legajo', defaultMessage: 'Legajo' })}
						name="legajoNumero"
						value={filtersState.legajoNumero}
						onChange={(e) => handleChange('legajoNumero', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'legajoNumero')}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.email', defaultMessage: 'Email' })}
						name="email"
						value={filtersState.email}
						onChange={(e) => handleChange('email', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'email')}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<TextField
						label={intl.formatMessage({ id: 'personasGrid.filtros.documento', defaultMessage: 'Nro. Documento' })}
						name="documentoNumero"
						value={filtersState.documentoNumero}
						onChange={(e) => handleChange('documentoNumero', e.target.value)}
						onKeyDown={(e) => handleOnEnter(e, 'documentoNumero')}
						className="col-12"
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<Autocomplete
						size="small"
						name="base"
						options={bases}
						value={filtersState.base}
						defaultValue={null}
						getOptionLabel={(option) => option ? option.label : ""}
						onChange={(_, value) => handleSelectChange('base', value)}
						renderInput={(params) => (
							<TextField {...params} variant="standard"
								label={intl.formatMessage({ id: 'personasGrid.filtros.base', defaultMessage: 'Base' })}
								placeholder={intl.formatMessage({ id: 'personasGrid.filtros.base', defaultMessage: 'Base' })}
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<React.Fragment>
											{params.InputProps.endAdornment}
										</React.Fragment>
									),
								}}
							/>
						)}
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<Autocomplete
						size="small"
						name="categoria"
						options={categorias}
						value={filtersState.categoria}
						defaultValue={null}
						getOptionLabel={(option) => option ? option.label : ""}
						onChange={(_, value) => handleSelectChange('categoria', value)}
						renderInput={(params) => (
							<TextField {...params} variant="standard"
								label={intl.formatMessage({ id: 'personasGrid.filtros.categoria', defaultMessage: 'Categoría' })}
								placeholder={intl.formatMessage({ id: 'personasGrid.filtros.categoria', defaultMessage: 'Categoría' })}
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<React.Fragment>
											{params.InputProps.endAdornment}
										</React.Fragment>
									),
								}}
							/>
						)}
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<Autocomplete
						size="small"
						name="perfil"
						options={perfiles}
						value={filtersState.perfil}
						defaultValue={null}
						getOptionLabel={(option) => option ? option.label : ""}
						onChange={(_, value) => handleSelectChange('perfil', value)}
						renderInput={(params) => (
							<TextField {...params} variant="standard"
								label={intl.formatMessage({ id: 'personasGrid.filtros.perfil', defaultMessage: 'Perfil' })}
								placeholder={intl.formatMessage({ id: 'personasGrid.filtros.perfil', defaultMessage: 'Perfil' })}
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<React.Fragment>
											{params.InputProps.endAdornment}
										</React.Fragment>
									),
								}}
							/>
						)}
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<Autocomplete
						size="small"
						name="region"
						options={regiones}
						value={filtersState.region}
						defaultValue={null}
						getOptionLabel={(option) => option ? option.label : ""}
						onChange={(_, value) => handleSelectChange('region', value)}
						renderInput={(params) => (
							<TextField {...params} variant="standard"
								label={intl.formatMessage({ id: 'personasGrid.filtros.region', defaultMessage: 'Región' })}
								placeholder={intl.formatMessage({ id: 'personasGrid.filtros.region', defaultMessage: 'Región' })}
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<React.Fragment>
											{params.InputProps.endAdornment}
										</React.Fragment>
									),
								}}
							/>
						)}
					/>
				</Grid>
				<Grid component={Box} item xs={12} sm={6} md={3} lg={2}>
					<Autocomplete
						size="small"
						name="subregion"
						options={subregiones}
						value={filtersState.subregion}
						defaultValue={null}
						getOptionLabel={(option) => option ? option.label : ""}
						onChange={(_, value) => handleSelectChange('subregion', value)}
						renderInput={(params) => (
							<TextField {...params} variant="standard"
								label={intl.formatMessage({ id: 'personasGrid.filtros.subregion', defaultMessage: 'Sub-Región' })}
								placeholder={intl.formatMessage({ id: 'personasGrid.filtros.subregion', defaultMessage: 'Sub-Región' })}
								InputProps={{
									...params.InputProps,
									endAdornment: (
										<React.Fragment>
											{params.InputProps.endAdornment}
										</React.Fragment>
									),
								}}
							/>
						)}
					/>
				</Grid>
				<Grid container item xs={12} spacing={2} alignItems="center">
					<Grid component={Box} item xs="auto" style={{ paddingRight: 20 }}>
						<div className="d-flex align-items-center" style={{ gap: 8 }}>
							<FormattedMessage
								id="personasGrid.filtros.ver_inactivos"
								defaultMessage="Ver Inactivos"
							/>
							<Switch
								onChange={(value) => handleSwitch('showInactivos', value)}
								checked={filtersState.showInactivos}
								offColor="#FF4961"
								onColor="#28D094"
							/>
						</div>
					</Grid>
					<Grid component={Box} item xs="auto" style={{ paddingRight: 20 }}>
						<div className="d-flex align-items-center" style={{ gap: 8 }}>
							<FormattedMessage
								id="personasGrid.filtros.persistir_filtros"
								defaultMessage="Persistir Filtros"
							/>
							<Switch
								onChange={(value) => handlePersistirFiltros(value)}
								checked={showPersistirFiltros}
								offColor="#FF4961"
								onColor="#28D094"
							/>
						</div>
					</Grid>
					<Grid component={Box} item style={{ flex: 1 }} />
					<Grid component={Box} item xs="auto">
						<button
							disabled={props.loading}
							className="btn btn-primary"
							onClick={() => handleBuscar()}
						>
							<i className="fa fa-search fa-xs"></i> <FormattedMessage id="Buscar" defaultMessage="Buscar"/>
						</button>
					</Grid>
				</Grid>
			</Grid>
		</Collapse>
	);
};

export default PersonasGridFiltros;
